import React, { useMemo } from 'react';
import './Leaderboard.css';

const Leaderboard = ({ navigateTo }) => {
    // Generate dynamic leaderboard data that changes daily
    const leaderboardData = useMemo(() => {
        // Get current date as seed (YYYY-MM-DD format)
        const today = new Date().toISOString().split('T')[0];
        
        // Convert date string to a number for seeding
        const seed = today.split('-').join('');
        
        // Seeded random number generator
        const seededRandom = (seed) => {
            let x = Math.sin(seed) * 10000;
            return x - Math.floor(x);
        };
        
        // Pool of realistic player names
        const playerNames = [
            "Alex", "Sarah", "Miguel", "Jessica", "David", "Emma", "John", "Lisa", 
            "Omar", "Sophia", "Ryan", "Maya", "Carlos", "Zoe", "Kevin", "Nina", 
            "Tyler", "Aria", "Lucas", "Chloe", "Mason", "Grace", "Ethan", "Lily",
            "Noah", "Mia", "Logan", "Ava", "Jackson", "Isabella", "Aiden", "Olivia",
            "Sebastian", "Charlotte", "Gabriel", "Amelia", "Julian", "Harper", "Mateo", "Evelyn",
            "Anthony", "Abigail", "Christopher", "Emily", "Joshua", "Elizabeth", "Andrew", "Sofia",
            "Daniel", "Avery", "Matthew", "Ella", "Samuel", "Madison", "Joseph", "Scarlett",
            "Levi", "Victoria", "Alexander", "Aria", "William", "Grace", "Benjamin", "Chloe",
            "Elijah", "Camila", "Luke", "Penelope", "Oliver", "Riley", "Henry", "Layla",
            "Carter", "Lillian", "Wyatt", "Nora", "Caleb", "Zoey", "Nathan", "Mila",
            "Isaac", "Aubrey", "Cooper", "Hannah", "Hunter", "Brooklyn", "Christian", "Zoe",
            "Landon", "Leah", "Jonathan", "Savannah", "Connor", "Audrey", "Adrian", "Claire",
            "Asher", "Bella", "Cameron", "Skylar", "Leo", "Lucy", "Theodore", "Paisley",
            "Jeremiah", "Everly", "Hudson", "Anna", "Robert", "Caroline", "Easton", "Nova",
            "Nolan", "Genesis", "Nicholas", "Emilia", "Ezra", "Kennedy", "Colton", "Samantha"
        ];
        
        // Generate 10 unique players with scores
        const players = [];
        const usedNames = new Set();
        let currentSeed = parseInt(seed);
        
        // Generate base scores (high to low)
        const baseScores = [
            Math.floor(seededRandom(currentSeed++) * 200) + 350, // 350-550
            Math.floor(seededRandom(currentSeed++) * 180) + 300, // 300-480
            Math.floor(seededRandom(currentSeed++) * 160) + 250, // 250-410
            Math.floor(seededRandom(currentSeed++) * 140) + 200, // 200-340
            Math.floor(seededRandom(currentSeed++) * 120) + 150, // 150-270
            Math.floor(seededRandom(currentSeed++) * 100) + 120, // 120-220
            Math.floor(seededRandom(currentSeed++) * 80) + 90,   // 90-170
            Math.floor(seededRandom(currentSeed++) * 70) + 70,   // 70-140
            Math.floor(seededRandom(currentSeed++) * 60) + 50,   // 50-110
            Math.floor(seededRandom(currentSeed++) * 50) + 30    // 30-80
        ];
        
        // Sort scores in descending order
        baseScores.sort((a, b) => b - a);
        
        for (let i = 0; i < 10; i++) {
            let playerName;
            
            // Get unique player name
            do {
                const nameIndex = Math.floor(seededRandom(currentSeed++) * playerNames.length);
                playerName = playerNames[nameIndex];
            } while (usedNames.has(playerName));
            
            usedNames.add(playerName);
            
            const score = baseScores[i];
            // Calculate level based on score (every 20 points = 1 level, starting from level 1)
            const level = Math.max(1, Math.floor(score / 20));
            
            players.push({
                rank: i + 1,
                name: playerName,
                score: score,
                level: level
            });
        }
        
        return players;
    }, []); // Empty dependency array means this only runs once per component mount (daily)

    return (
        <div className="leaderboard-container">
            <div className="leaderboard">
                <h1>Daily Leaderboard</h1>
                <p style={{ 
                    textAlign: 'center', 
                    color: '#666', 
                    marginBottom: '20px', 
                    fontSize: '14px' 
                }}>
                    Rankings update daily at midnight
                </p>
                
                <div className="leaderboard-header">
                    <div className="rank-column">Rank</div>
                    <div className="name-column">Player</div>
                    <div className="score-column">Score</div>
                    <div className="level-column">Level</div>
                </div>
                
                <div className="leaderboard-body">
                    {leaderboardData.map((entry) => (
                        <div key={entry.rank} className="leaderboard-row">
                            <div className={`rank-column rank-${entry.rank <= 3 ? ['gold', 'silver', 'bronze'][entry.rank - 1] : 'normal'}`}>
                                {entry.rank}
                            </div>
                            <div className="name-column">{entry.name}</div>
                            <div className="score-column">{entry.score}</div>
                            <div className="level-column">{entry.level}</div>
                        </div>
                    ))}
                </div>
                
                <button className="back-button" onClick={() => navigateTo('game')}>
                    Back to Game
                </button>
            </div>
        </div>
    );
};

export default Leaderboard; 